document.addEventListener('click', function (e) {
  const btn = e.target.closest('[data-instant-action-type="load-more"]');
  if (!btn) return;

  // Загальна кількість продуктів у колекції
  const totalProducts = parseInt(btn.getAttribute('data-instant-product-count') || '0', 10);

  // Кількість відмальованих продуктів у гріді
  const loadedProducts = document.querySelectorAll('[data-instant-repeater-index]').length;

  // Якщо вже все завантажено — блокуємо роботу Instant
  if (loadedProducts >= totalProducts && totalProducts > 0) {
    e.preventDefault();
    e.stopImmediatePropagation();
    btn.style.display = "none";
    console.log('[Instant FIX] Load-more disabled: all products loaded.');
    return false;
  }
});
